import { render, staticRenderFns } from "./Detail-Asset.vue?vue&type=template&id=046e9195"
import script from "./Detail-Asset.vue?vue&type=script&lang=js"
export * from "./Detail-Asset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports